/**
 * TocLink
 */
import React from 'react';
/** A link item to be used in the Toc-component. */
var TocLink = function (_a) {
    var href = _a.href, children = _a.children;
    return (React.createElement("a", { href: href, className: "text-p text-primary-2 hover:underline toc-link", "data-cid": "TocLink" }, children));
};
export default TocLink;
